'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultExport = new String('.slick-next{right:25px;}.slick-prev{z-index:999;left:25px;}.card .slick-dots li button:before{color:white;}.card .slick-dots li.slick-active button:before{color:white;}.slick-dots{bottom:0px;}');

_defaultExport.__hash = '2755937884';
_defaultExport.__scoped = '.slick-next.jsx-141513309{right:25px;}.slick-prev.jsx-141513309{z-index:999;left:25px;}.card.jsx-141513309 .slick-dots.jsx-141513309 li.jsx-141513309 button.jsx-141513309:before{color:white;}.card.jsx-141513309 .slick-dots.jsx-141513309 li.slick-active.jsx-141513309 button.jsx-141513309:before{color:white;}.slick-dots.jsx-141513309{bottom:0px;}';
_defaultExport.__scopedHash = '141513309';
exports.default = _defaultExport;